const lib = {
	node: {
		grid: '.downloads .tile-grid',
	},
	class: {
		single: 'downloads--single',
	},
};

// If the DOM is loaded, check if the download tile-grid has only one element and if so add a class to the parent container
document.addEventListener('DOMContentLoaded', function () {
	const downloadGrid = document.querySelector(lib.node.grid);

	if (downloadGrid?.children.length === 1) {
		downloadGrid.parentElement?.classList.add(lib.class.single);
	}
});
